export const enActions = {
  title: "Actions Hub",
  subtitle: "AI-generated actions to improve user experience and drive growth",
  connectionsButton: "Connections",
  list: {
    loadingAria: "Loading actions",
    emptyTitle: "No actions yet",
    emptySubtitle: "Actions taken from nugget recommendations will appear here.",
    integrationLine: "{{name}} · {{type}}",
    tabs: {
      pending: "Pending",
      success: "Success",
      failed: "Failed",
    },
  },
  connectionsHub: {
    backAria: "Back to Actions",
    backLabel: "Back to Actions",
    title: "Connections Hub",
    subtitle: "Manage integrations for action delivery",
    loadingAria: "Loading integrations",
    connectedSince: "Connected on {{date}}",
    addAnother: "Add integration",
    emptyTitle: "No integrations yet",
    emptySubtitle: "Connect an integration to deliver recommended actions from nuggets.",
    connectButton: "Add Integration",
    adminOnlyHint: "Ask an administrator to add an integration for this workspace.",
    modal: {
      title: "Add Integration",
      closeAria: "Close",
      fields: {
        type: "Integration type",
        name: "Name",
        namePlaceholder: "Slack",
        description: "Description",
        descriptionPlaceholder: "What this integration is used for",
        webhookUrl: "Webhook URL",
      },
      types: {
        slack: "Slack",
      },
      validation: {
        required: "Webhook URL is required.",
        invalidWebhookUrl: "Enter a valid Slack incoming webhook URL.",
      },
      errors: {
        saveFailed: "Could not add integration. Please try again.",
      },
      actions: {
        cancel: "Cancel",
        connect: "Connect",
      },
    },
  },
} as const;
